import { UiSkinKey } from './skin.type'

export const DEFAULT_UI_SKIN_KEY: UiSkinKey = 'v1'

export const UI_SKIN_KEYS: readonly UiSkinKey[] = ['v1', 'v2', 'v3']

export const UI_SKIN_OPTIONS: readonly { key: UiSkinKey; label: string; shortLabel: string; description: string }[] = [
	{ key: 'v1', label: 'V1 Theme', shortLabel: 'V1', description: 'Interface theme' },
	{ key: 'v2', label: 'V2 Theme', shortLabel: 'V2', description: 'Interface theme' },
	{ key: 'v3', label: 'V3 Theme', shortLabel: 'V3', description: 'Interface theme' },
]

export const UI_SKIN_BODY_CLASS_BY_KEY: Record<UiSkinKey, string> = {
	v1: 'ui-skin-v1',
	v2: 'ui-skin-v2',
	v3: 'ui-skin-v3',
}

export const UI_SKIN_BODY_CLASSES = Object.values(UI_SKIN_BODY_CLASS_BY_KEY)

export function resolveUiSkinKey(uiSkinKey?: string): UiSkinKey {
	const normalizedSkinKey = uiSkinKey?.trim()
	return UI_SKIN_KEYS.includes(normalizedSkinKey as UiSkinKey) ? (normalizedSkinKey as UiSkinKey) : DEFAULT_UI_SKIN_KEY
}
